import { UserTypes } from "src/model";
import * as IoIcons from "react-icons/io";

const mfbAccess = [UserTypes.ADMIN, UserTypes.USER];
const qoreAccess = [UserTypes.SUPER_ADMIN];
const all = [UserTypes.ADMIN, UserTypes.USER, UserTypes.SUPER_ADMIN];

export const sideBarData = (t: any, qoreStaffType?: string) => {
  return [
    {
      title: t("sideBar.appConfig.theme"),
      path: "/dashboard/app-design",
      menuCategory: "appConfig",
      accessType: mfbAccess,
    },
    {
      title: t("sideBar.appConfig.appDetails"),
      path: "/dashboard/app-details",
      menuCategory: "appConfig",
      accessType: mfbAccess,
    },
    {
      title: t("sideBar.appConfig.onboardSlides"),
      path: "/dashboard/onboarding-slides",
      menuCategory: "appConfig",
      accessType: mfbAccess,
    },
    {
      title: t("sideBar.appConfig.config"),
      path: "/dashboard/configuration",
      menuCategory: "appConfig",
      accessType: mfbAccess,
    },
    {
      title: t("sideBar.appConfig.features"),
      path: "/dashboard/feature-control",
      menuCategory: "appConfig",
      accessType: mfbAccess,
    },
    {
      title: t("sideBar.appConfig.appGeneration"),
      path: "/dashboard/app-generation",
      menuCategory: "appConfig",
      accessType: mfbAccess,
    },
    // {
    //     title: 'Manage Ads',
    //     path: '/dashboard/ads-management',
    //     menuCategory: 'feedManagement'
    // },
    {
      title: t("sideBar.feed.feed"),
      path: "",
      iconClosed: <IoIcons.IoIosArrowDown />,
      iconOpened: <IoIcons.IoIosArrowUp />,
      menuCategory: "feedManagement",
      accessType: mfbAccess,
      subNav: [
        {
          title: t("sideBar.feed.web"),
          path: "/dashboard/ibanking-feed",
        },
        {
          title: t("sideBar.feed.mobile"),
          path: "/dashboard/mbanking-feed",
        },
      ],
    },
    {
      title: t("sideBar.feed.notification"),
      path: "/dashboard/notification",
      menuCategory: "feedManagement",
      accessType: mfbAccess,
    },
    {
      title: t("sideBar.report.login"),
      path: "/dashboard/customer-login-report",
      menuCategory: "reports",
      accessType: mfbAccess,
    },
    {
      title: t("sideBar.report.failedTrans"),
      path: "/dashboard/failed-tx-report",
      menuCategory: "reports",
      accessType: mfbAccess,
    },
    {
      title: t("sideBar.report.transfer"),
      path: "/dashboard/transfer-report",
      menuCategory: "reports",
      accessType: mfbAccess,
    },
    {
      title: t("sideBar.report.bills"),
      path: "/dashboard/bill-payment-report",
      menuCategory: "reports",
      accessType: mfbAccess,
    },
    {
      title: t("sideBar.report.airtime"),
      path: "/dashboard/airtime-report",
      menuCategory: "reports",
      accessType: mfbAccess,
    },
    {
      title: t("sideBar.report.limit"),
      path: "/dashboard/tx-limit-report",
      menuCategory: "reports",
      accessType: mfbAccess,
    },
    {
      title: t("sideBar.report.fixed"),
      path: "/dashboard/fixed-deposit-report",
      menuCategory: "reports",
      accessType: mfbAccess,
    },
    // {
    //     title: 'Cardless Withrawals',
    //     path: '/dashboard/cardless-withdrawal-report',
    //     menuCategory: 'reports'
    // },
    {
      title: t("sideBar.report.loan"),
      path: "/dashboard/loans-report",
      menuCategory: "reports",
      accessType: mfbAccess,
    },
    // {
    //   title: t("sideBar.report.save"),
    //   path: "/dashboard/target-savings-report",
    //   menuCategory: "reports",
    //   accessType: mfbAccess,
    // },
    // {
    //   title: t("sideBar.report.cbp"),
    //   path: "/dashboard/cross-border-report",
    //   menuCategory: "reports",
    //   accessType: mfbAccess,
    // },
    {
      title: t("sideBar.customer.profile"),
      path: "/dashboard/customer-profile-report",
      menuCategory: "customers",
      accessType: mfbAccess,
    },
    {
      title: t("sideBar.customer.upgrade"),
      path: "/dashboard/account-upgrade-requests",
      menuCategory: "customers",
      accessType: mfbAccess,
    },
    // {
    //   title: t("sideBar.customer.cbp"),
    //   path: "/dashboard/cross-border-customer",
    //   menuCategory: "customers",
    //   accessType: mfbAccess,
    // },
    // {
    //   title: t("sideBar.customer.nonNigerianAccount"),
    //   path: "/dashboard/non-nigerian-account-request",
    //   menuCategory: "customers",
    //   accessType: mfbAccess,
    // },
    {
      title: t("sideBar.audit.auditReport"),
      path: "/dashboard/audit-report",
      menuCategory: "audit",
      accessType: all,
    },
    {
      title: t("sideBar.audit.loginReport"),
      path: "/dashboard/login-report",
      menuCategory: "audit",
      accessType: all,
    },
    {
      title: t("sideBar.audit.buildReport"),
      path: "/dashboard/app-generation-report",
      menuCategory: "audit",
      accessType: qoreAccess,
    },
    {
      title: t("sideBar.build.buildSettings"),
      path: "/dashboard/build-configuration",
      menuCategory: "configuration",
      accessType: qoreAccess,
    },
    {
      title: "Build Generation",
      path: "/dashboard/build-generation",
      menuCategory: "configuration",
      accessType: qoreAccess,
    },
  ];
};
